import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { FmRoutePage, FmSpinner, FmStack, FmText } from '@/components/ui';
import { useAuthContext } from '@/contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, checkAuth } = useAuthContext();
  const location = useLocation();

  useEffect(() => {
    // Check authentication status on mount
    checkAuth();
  }, [checkAuth]);

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <FmRoutePage fit="viewport" layout="column">
        <FmStack align="center" gap="md">
          <FmSpinner size="lg" />
          <FmText>Checking authentication...</FmText>
        </FmStack>
      </FmRoutePage>
    );
  }

  // Redirect to landing page with return URL if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location, authRequired: true }} replace />;
  }

  return children;
};

export default ProtectedRoute;
